<template>
    <div>
        <div class="modal" v-bind:class="{'is-active': adding_location}">
            <div class="modal-background"></div>
            <div class="modal-content modal-box">
                <article class="card">
                    <error-display v-if="has_error" :errors="errors"></error-display>
                    <form class="new-user-form" @submit.prevent="addLocation">
                        <div class="field">
                            <label class="label is-pulled-left">Location</label>
                            <div class="select">
                                <select v-model="user_new_location">
                                    <option disabled value="">Select A Location</option>
                                    <option
                                            v-for="option in locations"
                                            :key="option.id"
                                            v-bind:value="option">
                                        {{ option.location }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <hr>
                        <div>
                            <button class="button is-info level-item"
                                    v-bind:class="{'is-loading': location_submitting}">Add Location
                            </button>
                        </div>
                    </form>
                </article>
            </div>
            <button class="modal-close is-large" aria-label="close"
                    @click="adding_location = !adding_location"></button>
        </div>
        <div class="modal" v-bind:class="{'is-active': password_reset}">
            <div class="modal-background"></div>
            <div class="modal-content modal-box">
                <article class="card">
                    <form class="password-reset-form" @submit.prevent="changePassword">
                        <div class="field">
                            <label class="label is-pulled-left">New Password</label>
                            <div class="control">
                                <input class="input" type="text" v-model="new_user_password">
                            </div>
                        </div>
                        <hr>
                        <div>
                            <button class="button is-info level-item" v-bind:class="{'is-loading': location_submitting}">Change Password</button>
                        </div>
                    </form>
                </article>
            </div>
            <button class="modal-close is-large" aria-label="close" @click="password_reset = !password_reset"></button>
        </div>
        <div>
            <p class="level-item subtitle is-5">&nbsp</p>
        </div>
        <error-display v-if="this.has_error" :errors="this.errors"></error-display>
        <table class="table ">
            <tr>
                <td><strong>Name:</strong></td>
                <td>{{current_user.name}}</td>
            </tr>
            <tr>
                <td><strong>Email:</strong></td>
                <td>{{current_user.email}}</td>
            </tr>
            <tr>
                <td><strong>Account Created:</strong></td>
                <td>{{current_user.created_at}}</td>
            </tr>
            <tr>
                <td><strong>Default Location:</strong></td>
                <td>{{default_location_name}}</td>
            </tr>
            <tr v-if="this.$store.getters.isSuperAdmin">
                <label class="checkbox">
                    <input type="checkbox" v-model="current_user.global_admin" @change="makeAdmin()">
                    Global Admin
                </label>
            </tr>
            <tr v-if="this.$store.getters.isSuperAdmin">
                <td>
                    <button class="button is-info level-item" @click="password_reset = !password_reset">Reset Password
                    </button>
                </td>
            </tr>
        </table>
        <hr>
        <div class="level">
            <div class="level-left">
                <p class="level-item subtitle is-5">Locations</p>
            </div>
            <div class="level-right">
                <button class="button is-info level-item" @click="adding_location = !adding_location">Add Location
                </button>
            </div>
        </div>
        <hr>
        <table class="table">
            <tbody>
            <tr v-for="location in current_user.locations">
                <table class="table">
                    <tr>
                        <td>{{location.location}}</td>
                    </tr>
                    <tr>
                        <role-detail :roles="location.roles"></role-detail>
                    </tr>
                </table>
            </tr>
            </tbody>
        </table>

        <div v-if="this.$store.getters.isSuperAdmin" class="level">
            <div class="level-left">
                <button class="button is-danger" @click="deleteUser">Delete User</button>
            </div>
        </div>
    </div>
</template>

<script>
    import Loader from "./Loader";
    import RoleDetail from "./RoleDetail";
    import ErrorDisplay from "./ErrorDisplay";

    export default {
        name: "UserDetail",
        components: {ErrorDisplay, Loader, RoleDetail},
        props: {
            user: {
                type: Object,
                default: {}
            }
        },
        watch: {
            user: function (val, oldVal) {
                this.getUserDetail()
            },
        },
        data() {
            return {
                loading: false,
                current_user: {
                    name: null,
                    email: null,
                    global_admin: false,
                    default_location: ''
                },
                locations: [],
                locations_placeholder: '',
                has_error: false,
                errors: [],
                location_submitting: false,
                adding_location: false,
                password_reset: false,
                new_default_locaiton: '',
                default_location_name: '',
                temporary_password: ''
            }
        },
        mounted() {
            this.getUserDetail();
            this.getOptions();
            this.generatePassword();
        },
        methods: {
            generatePassword() {
                var length = 8,
                    charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
                    retVal = "";
                for (var i = 0, n = charset.length; i < length; ++i) {
                    retVal += charset.charAt(Math.floor(Math.random() * n));
                }
                this.new_user_password = retVal;
            },
            selectLocation() {
                let url = process.env.VUE_APP_API;
                url = url + "/admin/users/" + this.current_user.id;

                let data = {
                    data: {
                        default_location: this.current_user.default_location.id
                    }
                };

                this.$http.patch(url, data)
                    .then(resp => {
                        this.getUserDetail();
                    })
                    .catch(err => {
                        this.has_error = true;
                        this.errors = err.response.data.errors;
                        window.scrollTo(0, 0)
                    })
            },
            getUserDetail() {
                let user_id = this.user.id;
                this.loading = true;
                let url = process.env.VUE_APP_API;
                this.$http.get(url + "/admin/users/" + this.user.id)
                    .then(response => {
                        this.current_user = response.data.data;
                        this.loading = false;
                        this.isSuperAdmin();
                        this.getDefaultLocation();
                    })

            },
            isSuperAdmin() {
                let found = false;
                this.current_user.locations.forEach(function (location) {
                    let roles = location.roles;
                    roles.forEach(function (role) {
                        if (role.role_id === 4) {
                            found = true;
                        }
                    })
                });

                this.current_user.global_admin = found;
            },
            getDefaultLocation() {
                let location_id = this.current_user.default_location;
                let location_name = '';
                this.current_user.locations.forEach(function (location) {
                    if (location.id == location_id) {
                        location_name = location.location;
                    }
                });

                this.default_location_name = location_name;
            },
            makeAdmin() {
                let data = {
                    data: {
                        location_id: this.current_user.default_location,
                        role_id: 4
                    }
                };

                if (this.current_user.global_admin == true) {
                    let url = process.env.VUE_APP_API;
                    url = url + "/admin/users/" + this.current_user.id + "/roles/";
                    this.$http.post(url, data)
                        .then(resp => {
                            this.getUserDetail();
                        })
                        .catch(err => {
                            this.has_error = true;
                            this.errors = err.response.data.errors;
                        })
                } else {
                    let url = process.env.VUE_APP_API;
                    url = url + "/admin/users/" + this.current_user.id + "/locations/" + this.current_user.default_location + "/roles/" + data.data.role_id;
                    this.$http.delete(url)
                        .then(resp => {
                            this.getUserDetail();
                        })
                        .catch(err => {
                            this.has_error = true;
                            this.errors = err.response.data.errors;
                        })
                }

            },
            getOptions() {
                if (this.$store.getters.isSuperAdmin) {
                    let url = process.env.VUE_APP_API
                    url = url + '/locations/'
                    this.$http.get(url)
                        .then(response => {
                            this.locations = response.data.data
                            this.locations_placeholder = "Choose a Section"
                        })
                } else {
                    this.locations = this.$store.getters.adminLocations;
                }
            },
            addLocation() {
                let data = {
                    data: {
                        location_id: this.user_new_location.id,
                        role_id: 1
                    }
                };
                let url = process.env.VUE_APP_API;
                url = url + "/admin/users/" + this.current_user.id + "/roles"
                this.$http.post(url, data)
                    .then(resp => {
                        this.location_submitting = false;
                        this.adding_location = false;
                        this.getUserDetail();
                    })
                    .catch(err => {
                        this.adding_location = false;
                        this.location_submitting = false;
                        this.has_error = true;
                        this.errors = err.response.data.errors;
                    })
            },
            deleteUser() {
                let url = process.env.VUE_APP_API;
                url = url + "/admin/users/" + this.current_user.id;
                this.$http.delete(url)
                    .then(resp => {
                        this.location_submitting = false;
                        this.adding_location = false;
                        this.current_user = null;
                        this.$emit('deleted_user');
                    })
                    .catch(err => {
                        this.adding_location = false;
                        this.location_submitting = false;
                        this.has_error = true;
                        this.errors = err.response.data.errors;
                    })
            },
            changePassword(){
                let data = {
                    data: {
                        password_new : this.new_user_password
                    }
                };
                let url = process.env.VUE_APP_API;
                url = url + "/admin/users/" + this.current_user.id;
                this.$http.patch(url, data)
                    .then(resp => {
                        this.location_submitting = false;
                        this.adding_location = false;
                        this.password_reset = false;
                        this.getUserDetail();
                    })
                    .catch(err => {
                        this.adding_location = false;
                        this.location_submitting = false;
                        this.has_error = true;
                        this.errors = err.response.data.errors;
                        this.password_reset = false;
                    })
            }
        }
    }
</script>

<style scoped>
    label {
        padding: 15px;
    }

    .card {
        border-radius: 10px;
        padding: 35px;
    }

    .box {
        margin: 15px;
    }
</style>